import seedHelperFn from './seedHelperFn';
import {LOCATION_SEARCH_TEMPLATE} from './templates/queryTemplates';
import {PERSON_UGC_MUTATION_TEMPLATE} from './templates/mutationTemplates';
import {
  queryRequest,
  queryFailure,
  queryLocationSearchSuccess,
  mutatePersonUGCSuccess,
  mutatePersonUGCFailure,
} from './actions';

export const OPTIONS_TEMPLATE = {
  globalAction: null,
  yes: {
    position: 2,
    value: 'yes',
  },
  no: {
    position: 1,
    value: 'no',
  },
  skip: {
    position: 3,
    value: 'skip',
  },
};

export const QUESTION_TYPES = {
  validation: {},
  location: {
    group: [{required: 'state'}, {required: 'city'}],
  },
};

/**
 * Fetches location information from graphQL
 * @param  {object}   queryParams parameter to add to the query template
 * @return {function} returns the function to make the fetch
 */
export const queryLocationSearch = seedHelperFn(
  LOCATION_SEARCH_TEMPLATE,
  'query',
  queryRequest,
  queryLocationSearchSuccess,
  queryFailure
);

/**
 * Posts person's ugc data to graphQL
 * @param  {object}   mutationParams parameter to add to the mutation template
 * @return {function} returns the function to make the fetch
 */
export const mutatePersonUGC = seedHelperFn(
  PERSON_UGC_MUTATION_TEMPLATE,
  'mutation',
  queryRequest,
  mutatePersonUGCSuccess,
  mutatePersonUGCFailure
);



// WEBPACK FOOTER //
// ./src/reactModules/redux/ugcHelper.js